const event = {
  onGoingEvent: '진행중인 이벤트',
  closedEvent: '종료된 이벤트',
  emptyClosedEvent: '종료된 이벤트가 없습니다.',
  emptyOnGoingEvent: '현재 진행중인 이벤트가 없습니다.',
};

export default event;
